module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/mainView-pc_a5048028294004cafd731d90217e8b0d.png";